import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import EventValidator from '../../validators/EventValidator'
import InputField from '../Inputs/InputField'


class EventForm extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    waiting: false,
	    authorized: undefined
	}
    }
    componentDidMount(){
	
    }
    
    render() {
	const { handleSubmit, successAction } = this.props
	let {waiting} = this.state

	const submit = (values, dispatch, props) => {
	    let errors = EventValidator( values, props ) || {};
	    waiting=true
	    this.setState({waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {
		let saveAction = values.id ? props.updateEvent : props.saveEvent

		
		saveAction(values).then((res) => {
		    waiting=false
		    this.setState({waiting})
		    props.reset()
		    successAction()
		}).catch((err) => {
		    waiting=false
		    this.setState({waiting})
		    console.log(err)})
	    }
	}


	return (

	    <form onSubmit={handleSubmit(submit)}>
		<InputField name="category" type="select" label="Tipologija" options={[{value: '', name: 'Novica'}, {value: 'event', name: 'Dogodek'}]} />


		<InputField name="youtube_id" type="text" label="id youtube"  />
		<InputField name="title" type="text" label="Naslov" />
		<InputField name="subtitle" type="text" label="Podnaslov" />
		
		<div style={{display: (this.props.getFormValue('category') ? 'block' : 'none' )}}>
		    <InputField name="title_position" type="select" label="Pozicija teksta" options={[{value: '', name: 'Zberi'}, {value: 'top', name: 'Zgoraj'}, {value: 'bottom', name: 'Spodaj'}]} />
		    <InputField name="title_font" type="select" label="Font" options={[{value: '', name: 'Zberi'}, {value: 'regular', name: 'Regular'}, {value: 'condensed', name: 'Condensed'}]} />
		    <InputField name="location" type="text" label="Kraj dogodka"  />
		    <InputField name="event_on" type="datetime" label="Datum dogodka"  />
		    
		</div>
		
		
		
		

		<InputField name="description" type="textarea" label="Opis" />
		<button type="submit" disabled={this.props.invalid || waiting} className="btn btn-brown btn-big full-width" >
		    <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		    {
			this.props.invalid ?
			'Pomankljivosti v unosu podtkov poglej zgoraj'
			:
			'Sharni'
		    }
		</button>
	    </form>
	);
    }
}

export default reduxForm({
    form: 'event',
    validate: EventValidator,
    enableReinitialize: true
})(EventForm);



// WEBPACK FOOTER //
// ./src/components/EventForm/index.jsx